import { ClosingBand } from "@/features/portal/components/closing-band";
import { CoachView } from "@/features/portal/modules/coach-view/coach-view";
import type { BookableTrainer } from "@/features/portal/modules/coaches/coach-directory";
import { DietScan } from "@/features/portal/modules/diet/diet-scan";
import { FeaturesRail } from "@/features/portal/modules/features-rail/features-rail";
import { ForCoaches } from "@/features/portal/modules/for-coaches/for-coaches";
import { DayReminders } from "@/features/portal/modules/reminders/day-reminders";
import { GoalRhythm } from "@/features/portal/modules/rhythm/goal-rhythm";
import { SpecialistSearch } from "@/features/portal/modules/specialist-search/specialist-search";
import { PortalSteps } from "@/features/portal/modules/steps/portal-steps";
import { WeekBand } from "@/features/portal/modules/week/week-band";

/**
 * Everything under the hero, one point per section and each laid out its own way, so the page
 * reads as a walk through the app rather than a stack of the same block: who to train with, what
 * is in the app, how to start, then the diet, the week, the rhythm with a coach, what the coach sees
 * and what lands in the inbox. It ends where every page of the tour does, on the ask; the note for
 * coaches stays after it, since it is not for the people the ask is for.
 */
export const PortalWelcome = ({ trainers }: { trainers: BookableTrainer[] }) => (
  <>
    <SpecialistSearch trainers={trainers} />
    <FeaturesRail />
    <PortalSteps />
    <DietScan />
    <WeekBand />
    <GoalRhythm />
    <CoachView />
    <DayReminders />
    <ClosingBand />
    <ForCoaches />
  </>
);
